import { titleize } from 'inflected';
import { MetadataEntityFieldData, MetadataEntityFieldType, defaultMetadataFlagTypeData } from './model';
import { getMetadataEntityFieldType, getMetadataEntityFilterType, getMetadataEntityFilterV2 } from './utilities';
import { getMetadataEntityFieldDataDefaults } from './utilities/get.entity.field.defaults';
import * as Enumerable from 'linq'

export const MetadataField = (options?: Partial<MetadataEntityFieldData>): PropertyDecorator => {
    return (target: any, propertyKey: string | symbol): void => {

        const ctor = target.constructor;

        if (!Object.getOwnPropertyDescriptor(ctor, '__meta_fields__')) {
            Object.defineProperty(ctor, '__meta_fields__', {
                value: [],
                writable: true,
                enumerable: true,
            });
        }

        const field = {
            ...getMetadataEntityFieldDataDefaults(),
            name: propertyKey,
            path: propertyKey,
            displayName: titleize(propertyKey as string),
            ...options
        } as MetadataEntityFieldData;

        const type = getMetadataEntityFieldType(field);
        if (type === MetadataEntityFieldType.Flag) {
            field.typeData = defaultMetadataFlagTypeData();
        }

        field.filterType = getMetadataEntityFilterType(field);
        field.filter = field?.filter ?? getMetadataEntityFilterV2(type);

        const safeSet = new Map<string, MetadataEntityFieldData>();
        Enumerable
            .from((Object?.getPrototypeOf(ctor)?.__meta_fields__ ?? []) as MetadataEntityFieldData[])
            .concat(ctor.__meta_fields__)
            .concat([field])
            .forEach(x => safeSet.set(x.name, x));

        // const set = new Set([
        //     ...(Object?.getPrototypeOf(ctor)?.__meta_fields__ ?? []),
        //     ...ctor.__meta_fields__,
        //     field,
        // ]);

        ctor.__meta_fields__ = Array.from(safeSet.values());
    };
};